module.exports = __webpack_public_path__ + "static/media/BIRMINGHAM_AES_LOGO.730964b1.png";